import { AiBlockType } from '@/levity/aiblocks/types';
import { outlookOperationsDefinition } from '@/levity/integrations/registry/email/providers/outlook.definitions';
import { IntegrationAuthApp } from '@/levity/integrations/types';

import { DYNAMIC_EDITOR_TAG_EXTENSION_NAME } from '../../../../components/dynamic-input/constants';
import { AppNodeType, FlowNodeType, type FlowTemplate } from '../../types';

export const classifyEmails: FlowTemplate = {
  name: 'classify-emails-outlook',
  description: 'Classify incoming emails and update labels in Outlook',
  integrations: [IntegrationAuthApp.microsoftTeamsV2],
  title: 'Classify incoming emails and update labels in Outlook',
  nodes: [
    {
      id: 'b60ddaac-4be3-48e7-8c24-94cd59318601',
      type: FlowNodeType.APP,
      icon: `/imgs/icons/${IntegrationAuthApp.microsoftTeams}.svg`,
      metadata: {
        integration: IntegrationAuthApp.microsoftTeamsV2,
        type: AppNodeType.TRIGGER,
        operationId: outlookOperationsDefinition.GetAllMessages.id,
      },
    },
    {
      id: '76b36ba0-c3ed-4c2a-96a4-8bb163b8c09a',
      type: FlowNodeType.AI_BLOCK,
      icon: `/imgs/icons/aiblocks/${AiBlockType.classify}.svg`,
      metadata: {
        aiBlockId: '86c5842d-45d9-43a9-9439-4f4d793a2ba0',
      },
      defaultDynamicInputContent: [
        {
          type: DYNAMIC_EDITOR_TAG_EXTENSION_NAME,
          attrs: {
            dynamicTag: {
              operation: outlookOperationsDefinition.GetAllMessages.id,
              key: 'Body',
              image: {
                alt: 'microsoftTeams application icon',
                src: '/imgs/icons/microsoftTeams.svg',
              },
            },
          },
        },
      ],
    },
    {
      id: '4fced893-5fe7-41c3-b185-2fba6a943ea3',
      type: FlowNodeType.APP,
      icon: `/imgs/icons/${IntegrationAuthApp.microsoftTeams}.svg`,
      metadata: {
        integration: IntegrationAuthApp.microsoftTeamsV2,
        type: AppNodeType.TARGET,
        operationId: outlookOperationsDefinition.CategorizeListOfMessages.id,
      },
      defaultDynamicInputContent: [
        {
          type: DYNAMIC_EDITOR_TAG_EXTENSION_NAME,
          attrs: {
            dynamicTag: {
              operation: 'llm-classify-with-block-labels',
              key: 'Classification Result',
              image: {
                alt: 'llm application icon',
                src: '/imgs/icons/llm.svg',
              },
            },
          },
        },
      ],
    },
  ],
  edges: [
    {
      sourceHandle: 'source',
      targetHandle: 'target',
      sourceId: 'b60ddaac-4be3-48e7-8c24-94cd59318601',
      targetId: '76b36ba0-c3ed-4c2a-96a4-8bb163b8c09a',
    },
    {
      sourceHandle: 'source',
      targetHandle: 'target',
      sourceId: '76b36ba0-c3ed-4c2a-96a4-8bb163b8c09a',
      targetId: '4fced893-5fe7-41c3-b185-2fba6a943ea3',
    },
  ],
  aiBlocks: [
    {
      id: '86c5842d-45d9-43a9-9439-4f4d793a2ba0',
      name: 'Classify email',
      emoji: '🦋',
      type: AiBlockType.classify,
    },
  ],
};
